-<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" *ngIf="navigationName != 'Search'">
  <ol class="breadcrumb breadcrumb_bg">
    <li *ngFor="let breadcrumb of documentBreadcrumbList; let i = index" class="breadcrumb-item breamcrumb-text"
      [ngClass]="i+1 == documentBreadcrumbList.length ? 'lastNode' : ''">
      <span *ngIf="i == documentBreadcrumbList.length - 2" (click)="backToFolderWise()" versionValueDropdown
        style="cursor: pointer">{{
        breadcrumb }}</span>
      <span *ngIf="i != documentBreadcrumbList.length - 2">{{
        breadcrumb
        }}</span>
    </li>
  </ol>
</nav>
<div *ngIf="navigationName == 'Search'"><app-breadcrumb></app-breadcrumb></div>

<div *ngIf="navigationName == 'Search'">
  <p class="search_title mb-3">
    Search Document By
    <span class="mandatory-symbol ms-0">*</span>
  </p>
</div>
<div *ngIf="navigationName == 'Search'" class="d-flex gap-5 align-items-center">
  <div class="search_block">
    <div class="d-flex gap-4 p-2">
      <div class="document_type">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedSearchValue" (closed)="documentSearchText=''"
          (click)="focusSearch('focus-document-by-search')">
          <input type="search" id="focus-document-by-search" class="dropdownsearchstyle"
            [(ngModel)]="documentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of dropDownForSearchValue | assessmentSearch : documentSearchText;"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="line_divider"></div>
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control dms_search_input" style="font-size: 12px" placeholder="Search here..."
          [(ngModel)]="docIdOrName" />
      </div>
    </div>
  </div>
  <div class="d-flex gap-3">
    <div class="search_icon_block d-flex align-items-center justify-content-center pointer" (click)="searchDocuments()">
      <img alt="" src="../../assets/img/training_module/search_icon.svg" width="12px" height="12px" alt="" />
    </div>
    <div class="redo_block d-flex align-items-center justify-content-center pointer" (click)="resetDocSearch()">
      <img alt="" src="../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="" />
    </div>
  </div>
</div>

<div class="position-relative cr_content h-auto table-container" [hidden]="!isShowSearchedGrid" style="margin-top:0px">

  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex gap-3">
    </div>
    <div class="d-flex gap-3">
      <div>
        <div class="">
          <div class="search-container">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
              [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
          </div>
        </div>
      </div>

      <div
        *ngIf="navigationName != 'Search' && (isShowBulkCheckInButton || isShowBulkSelfLockButton || isShowBulkPublishButton)"
        ngbDropdown class="d-inline-block">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" id="bulkActionsDropdown"
          ngbDropdownToggle style="cursor: pointer;">
          <span class="reload_text text-white">More Actions</span>
          <i class="fa fa-caret-down text-white"></i>
        </div>
        <div ngbDropdownMenu aria-labelledby="bulkActionsDropdown">
          <button ngbDropdownItem *ngIf="isShowBulkCheckInButton" (click)="openBulkActionPopup('CheckIn')">
            Bulk CheckIn
          </button>
          <button ngbDropdownItem *ngIf="isShowBulkSelfLockButton" (click)="openBulkActionPopup('Self Lock')">
            Bulk Self Lock
          </button>
          <button ngbDropdownItem *ngIf="isShowBulkPublishButton" (click)="openBulkActionPopup('Publish')">
            Bulk Publish
          </button>
        </div>
      </div>
      <!-- End of Collapsed Dropdown -->

      <div *ngIf="isShowAddFolderButton" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addFolderFunc()">
        <i class="fa fa-folder" style="color: white;"></i>
        <span class="reload_text text-white">Add Folder</span>
      </div>
      <div *ngIf="isShowAddDocumentButton"
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addPlaceholderFunc()">
        <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add Document</span>
      </div>
      <div *ngIf="parentFolderData.isDistributedFolder == 'Y' && isShowAddFolderButton"
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="mapFolderOpenPopup()">
        <i class="fa fa-folder-open-o" style="color: white;"></i>
        <span class="reload_text text-white">Map Folder</span>
      </div>
      <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshFunc()">
        <img alt="" src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
        <span class="reload_text">Reload</span>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container">
    <tr>
      <th class="py-2" style="min-width: 60px;width:60px;max-width:60px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Type</span>
          <img alt="" src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="min-width: 400px;width:400px;max-width:500px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Title</span>
          <img alt="" src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="min-width: 250px;width:250px;max-width:500px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Status</span>
          <img alt="" src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="min-width: 400px;width:400px;max-width:570px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Actions</span>
          <img alt="" src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="min-width: 250px;width:250px;max-width:250px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Activity</span>
          <img alt="" src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
    </tr>
    <tr *ngFor="
        let object of pagedItems | searchFilter : searchValue;
        let i = index
      " (dblclick)="goToSubfolderPage(object)" (contextmenu)="onRightClick($event, object)">
      <td style="width: 100px" *ngIf="object.type == 'Folder'">
        <div style="display: flex">
          <i class="fa fa-folder-open" style="
              margin-top: 7%;
              font-size: 30px;
              color: #f1ca0ad1;
              margin-left: 30%;
            "></i>
          <img alt="" *ngIf="object.isDistributedFolder == 'Y'" src="../../assets/img/DMS/distributed.svg"
            style="height: 18px;margin-top:18%;margin-left: -30%;" />
        </div>
      </td>
      <td *ngIf="object.type == 'Document'">
        <div class="text-center" *ngIf="object.documentExtn == 'txt' || object.documentExtn == 'TXT'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;"
            src="../../assets/img/txt-file-extension--open-txt-files-10.png" />
        </div>
        <div class="text-center"
          *ngIf="object.documentExtn == 'doc' || object.documentExtn == 'DOC' || object.documentExtn == 'docx' || object.documentExtn == 'DOCX'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/doc.jpg" />
        </div>
        <div class="text-center"
          *ngIf="object.documentExtn == 'xl' || object.documentExtn == 'XL' || object.documentExtn == 'xlsx' || object.documentExtn == 'XLSX'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/xl.png" />
        </div>
        <div class="text-center" class="text-center"
          *ngIf="object.documentExtn == 'xml' || object.documentExtn == 'XML'">
          <img alt="" style="margin-top: 7%; height: 30px;" src="../../assets/img/xml.jpg" />
        </div>
        <div class="text-center" class="text-center" *ngIf="object.documentExtn == 'zip'">
          <img alt="" style="margin-top: 7%; height: 30px;" src="../../assets/img/zip.png" />
        </div>
        <div class="text-center" class="text-center" *ngIf="object.documentExtn == 'svg'">
          <img alt="" style="margin-top: 7%; height: 30px;" src="../../assets/img/svg.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'png' || object.documentExtn == 'PNG'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/png.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'jpg' || object.documentExtn == 'JPG'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/jpg.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'pdf' || object.documentExtn == 'PDF'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/pdf.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'html' || object.documentExtn == 'HTML'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/htmlimages.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'csv' || object.documentExtn == 'CSV'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/csv.png" />
        </div>
        <div class="text-center" *ngIf="
            object.documentExtn == 'mp4' ||
            object.documentExtn == 'e' ||
            object.documentExtn == 'erd' ||
            object.documentExtn == 'eeg'
          ">
          <img alt="" src="../../assets/img/DMS/video.svg" width="24px" height="24px" alt="video" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'mp3' || object.documentExtn == 'MP3'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/audio.png" />
        </div>
        <div class="text-center" *ngIf="object.documentExtn == 'ppt' || object.documentExtn == 'pptx'">
          <img alt="" class="text-center" style="margin-top: 7%; height: 30px;" src="../../assets/img/DMS/ppt.svg" />
        </div>

        <div class="text-center" *ngIf="object.documentExtn == null">
          <i class="fa fa-plus-square-o" style="
              font-size: 30px;
              color: grey;
            "></i>
        </div>
      </td>
      <td *ngIf="object.type == 'Folder'">
        <div>
          <div>
            <span>{{ object.folderName }}</span>
            <span *ngIf="object.status == 'Inactive'" style="color: red"><b>&nbsp;&#10060;</b></span>
            <span *ngIf="object.status == 'Locked'" style="color: red"><b>🔒</b></span>
          </div>
          <div>
            <span *ngIf="object.folderCode != null">Code : {{ object.folderCode }}</span>
          </div>
          <div>
            <span *ngIf="object.folderDescription != null">Description : {{ object.folderDescription }}</span>
          </div>
          <div>
            <span *ngIf="object.documentTypeName != null">Type : {{ object.documentTypeName }}</span>
          </div>
        </div>
      </td>
      <td *ngIf="object.type == 'Document'">
        <div>
          <div class="mt-1">
            <span>{{ object.documentNo }}(v-{{ object.version }})</span>

            &nbsp;
            <span *ngIf="object.expired">
              <img alt="" src="../../assets/img/expired.png" title="Expired" style="height: 20px" />
            </span>
          </div>
          <div class="mt-1">
            <span class="file_name"> {{ object.documentName }}.{{ object.documentExtn }}</span>
          </div>
          <div class="d-flex justify-content-between mt-1">
            <div>
              <span class="document_feature" *ngIf="!object.documentSizeInKb.includes(null)">Size : {{
                object.documentSizeInKb }}</span>
            </div>
            <div>
              <span class="document_feature" *ngIf="object.documentTypeName != null">Type : {{ object.documentTypeName
                }}</span>
            </div>
          </div>
          <div class="d-flex gap-2 mt-1">
            <span class="extension_status" *ngIf="object.isExtensionInProgress == 'Y'">Extension Inprogress</span>
            <br *ngIf="object.isExtensionInProgress == 'Y'" />
            <span class="extension_status" *ngIf="object.isAmendmentInProgress == 'Y'">Amendment Inprogress</span>
            <br *ngIf="object.isAmendmentInProgress == 'Y'" />
            <span class="extension_status" *ngIf="object.isWithdrawalInProgress == 'Y'">Withdrawal Inprogress</span>
            <br *ngIf="object.isWithdrawalInProgress == 'Y'" />
            <span class="extension_status" *ngIf="object.isDestructionInProgress == 'Y'">Destruction Inprogress</span>
          </div>
          <div class="mt-1">
            <span *ngIf="object.isBlinded == 'U'" style="color: blue">Document is Unblinded</span>
            <br *ngIf="object.isBlinded == 'U'" />
            <span *ngIf="object.isBlinded == 'Y'" style="color: blue">Document is Blinded</span>
          </div>
          <div class="mt-1" *ngIf="navigationName == 'Search'">
            <span class="document_feature">Folder Path : {{ object.documentsSearchVwPk.folderPath
              }}
              <span *ngIf="object.documentsSearchVwPk.docContainer =='Distributed'">
                <i class="fa fa-folder-open" style=" 
                      font-size: 12px;
                      color: #f1ca0ad1;
                    "></i>
                <img alt="" src="../../assets/img/DMS/distributed.svg" style="margin-top:-2%;margin-left: -2%;" />
              </span></span>
          </div>
        </div>
      </td>

      <td>
        <span [ngClass]="object.status == 'Inactive' ||
        object.status == 'Locked' ||
        object.status == 'Expired' ||
        object.status == 'Approval Rejected' ||
        object.status == 'Review Rejected' ||
        object.status.includes('Requested More Info.') ||
        object.status.includes('Expired') ||
        object.status.includes('Inactive') ||
        object.status == 'Signoff Rejected' ||
        object.status == 'Obsoleted' ||
        object.status == 'Deleted' ? 'delete' : object.status == 'Active' ? 'approve'
        :object.status == 'Withdrawn' ? 'withdraw' : object.status == 'Open' ||
        object.status == 'Draft' ||
        object.status == 'Pending Review' ||
        object.status == 'Pending Approval' ||
        object.status.includes('Inprogress') ||
        object.status == 'Pending Publish' ||
        object.status == 'Pending Signoff' ? 'draft' :  object.status == 'Published' ||
        object.status.includes('Completed') ? 'closed' :''">{{ object.status }}</span>
        <span *ngIf="object.status == 'Place Holder'" style="color: purple">({{ object.status }})
        </span>
      </td>

      <td>
        <div *ngIf="object.checkoutFlag == 'Y' && object.checkedoutBy != null">
          <span>CheckedOut On / By :
            {{ object.checkedoutOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.checkedoutByUser }}</span>
        </div>
        <div *ngIf="object.checkoutFlag == 'N' && object.checkedoutBy != null">
          <span>Locked By : {{ object.checkedoutByUser }}</span>
        </div>
        <div *ngIf="object.checkedoutBy == null && object.type == 'Document'">
          <span>Created On / Author :
            {{ object.createdOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.checkedinByUser }}</span>
        </div>
        <div *ngIf="object.checkedoutBy == null && object.type == 'Folder'">
          <span>Created On / By :
            {{ object.createdOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.createdByUser }}</span>
        </div>
        <div *ngIf="object.type == 'Folder'">
          <span>Updated On / By :
            {{ object.updatedOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.updatedByUser }}</span>
        </div>
        <div *ngIf="object.effectiveDate != null">
          <span>Effective From Date :
            {{ object.effectiveDate | date : uiDateFormat | uppercase }}</span>
        </div>
        <div *ngIf="object.expirationDate != null">
          <span>Expiration Date :
            {{ object.expirationDate | date : uiDateFormat | uppercase }}</span>
        </div>
        <div *ngIf="object.crDetails != null">
          <span>CR : {{ object.crDetails }}</span>
        </div>
      </td>
      <td>
        <div *ngIf="object.belongsUser != null">
          <span>Belongs To : {{ object.belongsUser }}</span>
        </div>
        <div *ngIf="object.associatedDocumentNo != null">
          <span>Associated Document: {{ object.associatedDocumentNo }} (<span *ngIf="
                object.associatedDocumentFromVersion ==
                object.associatedDocumentToVersion
              ">
              {{ object.associatedDocumentFromVersion }}</span>
            <span *ngIf="
                object.associatedDocumentFromVersion !=
                object.associatedDocumentToVersion
              ">
              {{ object.associatedDocumentFromVersion }} -
              {{ object.associatedDocumentToVersion }}</span>
            )</span>
        </div>
        <div *ngIf="object.templateId != null">
          <span>Template : {{ object.templateName }}</span>
        </div>
        <div *ngIf="
            object.noOfCompletedExtension != null &&
            object.noOfCompletedExtension != 0
          ">
          <span>Completed Extension : {{ object.noOfCompletedExtension }}</span>
        </div>
        <div *ngIf="
            object.noOfCompletedAmendment != null &&
            object.noOfCompletedAmendment != 0
          ">
          <span>Completed Amendment : {{ object.noOfCompletedAmendment }}</span>
        </div>
      </td>
    </tr>
  </table>

  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="pagination_text mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

  <div style="visibility: hidden; position: fixed" [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>

  <!-- standard material menu -->
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button class="right_click_border" *ngFor="let button of item" mat-menu-item
        (click)="performOperationFunc(button)">
        <div class="d-flex gap-2 align-items-center">
          <span class="{{ button.icons }}"></span>
          <span class="right_click_actions">{{button.text}}</span>
        </div>
      </button>
    </ng-template>
  </mat-menu>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer" style="height: auto !important">
      <div class="row">
        <div class="col-md-8" style="margin-bottom: 10px">
          <div>
            <label for="email ">Folder Name</label><span class="mandatory-symbol">*</span>
          </div>
          <input id="folderName" class="input-filed-continers" type="text" [(ngModel)]="folderData.folderName" />
          <span id="folderName-required-msg">Please enter a folder name</span>
        </div>
        <div class="col-md-4">
          <div><label for="email ">Folder Code</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.folderCode"
            (keydown)="validateCodeFields($event)" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Is Distributed Folder?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.isDistributedFolder1"
            [disabled]="parentFolderData.isDistributedFolder == 'Y'">
            <span class="active-inActive-container" *ngIf="folderData.isDistributedFolder1 == true" [ngStyle]="
                folderData.isDistributedFolder1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.isDistributedFolder1 == false" [ngStyle]="
                folderData.isDistributedFolder1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-9" *ngIf="folderData.isDistributedFolder1 == false">
          <div><label for="email">Document Type</label></div>
          <mat-select matInput multiple placeholder="Select" #documentTypeId [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="documentTypeSelection" (change)="toggleAllSelection('documentType')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp" (onSelectionChange)="ondocumentTypeSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" *ngIf="folderData.isDistributedFolder1 == false">
        <div class="col-md-4">
          <div><label for="email">Override Document No Format at Folder?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.overrideDocumentNumberFormatAtFolder">
            <span class="active-inActive-container" *ngIf="folderData.overrideDocumentNumberFormatAtFolder == true"
              [ngStyle]="
                folderData.overrideDocumentNumberFormatAtFolder == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.overrideDocumentNumberFormatAtFolder == false" [ngStyle]="
                folderData.overrideDocumentNumberFormatAtFolder == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="settingsObj.allowToInputDocumentNoManually == 'Y'">
          <div><label for="email">Allow To Input Document No. Manually?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.allowToInputDocumentNoManually1">
            <span class="active-inActive-container" *ngIf="folderData.allowToInputDocumentNoManually1 == true"
              [ngStyle]="
                folderData.allowToInputDocumentNoManually1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.allowToInputDocumentNoManually1 == false" [ngStyle]="
                folderData.allowToInputDocumentNoManually1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="settingsObj.allowToInputVersionManually == 'Y'">
          <div><label for="email">Allow To Input Version Manually?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.allowToInputVersionManually1">
            <span class="active-inActive-container" *ngIf="folderData.allowToInputVersionManually1 == true" [ngStyle]="
                folderData.allowToInputVersionManually1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.allowToInputVersionManually1 == false" [ngStyle]="
                folderData.allowToInputVersionManually1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-4">
          <div><label for="email">Enable Publish Mail For Folder Users?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.enablePublishMailForFolderUsers1">
            <span class="active-inActive-container" *ngIf="folderData.enablePublishMailForFolderUsers1 == true"
              [ngStyle]="
                folderData.enablePublishMailForFolderUsers1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.enablePublishMailForFolderUsers1 == false" [ngStyle]="
                folderData.enablePublishMailForFolderUsers1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row" *ngIf="folderData.overrideDocumentNumberFormatAtFolder">
        <div class="col-md-4">
          <div><label for="email">Document No. Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.documentNoFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">Document No. Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.documentNoRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">Document Number No. of Digits</label></div>
          <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
            [(ngModel)]="folderData.documentNoNoOfDigits">
        </div>
      </div>
      <br />
      <div class="row" style="margin-bottom: 2%">
        <div class="col-md-12">
          <div><label for="email ">Folder Description</label></div>
          <textarea id="description" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="folderData.folderDescription"></textarea>
        </div>
      </div>
      <div class="row" style="margin-bottom: 2%" [hidden]="visibleAddButton">
        <div class="col-md-12">
          <div><label for="email ">Update Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="updateReason" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="folderData.updateReason"></textarea>
          <span id="updateReason-required-msg">Please enter update reason</span>
        </div>
      </div>
      <br [hidden]="visibleAddButton">
      <div class="row" *ngIf="visibleAddButton" style="margin-bottom: 2%">
        <div class="col-md-8">
          <div><label for="email">Groups</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUserGroups" (closed)="groupsSearchText=''"
            (click)="focusSearch('focus-location-search')">
            <input type="search" id="focus-location-search" class="dropdownsearchstyle" [(ngModel)]="groupsSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userGroupsDropdown | assessmentSearch : groupsSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-md-4">
          <div>
            <label for="email">Cascade Privilege To Child Folders</label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="cascaseToChild">
            <span class="active-inActive-container" *ngIf="cascaseToChild == true" [ngStyle]="
                cascaseToChild == true ? { color: 'green' } : { color: '' }
              ">Yes</span>
            <span *ngIf="cascaseToChild == false" [ngStyle]="
                cascaseToChild == false ? { color: 'red' } : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(folderData)" *ngIf="!visibleEditButton">
      <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(folderData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="deleteTextarea" type="text" class="input-filed-continers uppercase" rows="4" cols="50"
            [(ngModel)]="deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #addAndEditPlaceholderPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditPlaFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-radio-group [(ngModel)]="documentAddOption" (change)="chooseOptionOfAdd(documentAddOption)">
          <mat-radio-button *ngFor="let val of documentAddOptions" [value]="val">{{ val }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <br />
    <div class="form-continer" style="height: auto;max-height: 570px;" *ngIf="documentAddOption == 'Add PlaceHolder'">
      <div class="row" style="margin-left: 0px">
        <div class="row">
          <div class="col-md-6">
            <div>
              <label for="email ">Placeholder Name</label><span class="mandatory-symbol">*</span>
            </div>
            <input id="placeholderName" class="input-filed-continers" type="text"
              [(ngModel)]="placeholderData.documentName" />
            <span id="placeholderName-required-msg">Please enter a document name</span>
          </div>
          <div class="col-md-2" *ngIf="isVersionManually || placeholderData.documentId != null">
            <div><label for="email ">Version</label><span *ngIf="isVersionManually" class="mandatory-symbol">*</span>
            </div>
            <input id="version" class="input-filed-continers" type="number" [(ngModel)]="placeholderData.version"
              [disabled]="
                      placeholderData.documentId != null &&
                      isVersionManually == false 
                    " (keypress)="validateVersion($event)" />
            <span id="version-required-msg">Please enter a document version</span>
          </div>
          <div class="col-md-4" *ngIf="isDocumentNoManually || placeholderData.documentId != null">
            <div><label for="email ">Document No.</label><span *ngIf="isDocumentNoManually"
                class="mandatory-symbol">*</span>
            </div>
            <input id="documentNo" class="input-filed-continers" type="text" [(ngModel)]="placeholderData.documentNo"
              [disabled]="
                      placeholderData.documentId != null &&
                      isDocumentNoManually == false 
                    " />
            <span id="documentNo-required-msg">Please enter a document number</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div>
              <label for="email">Document Type</label><span class="mandatory-symbol">*</span>
            </div>
            <mat-select id="documentTypeForPlaceholder" matInput placeholder="Select"
              [(ngModel)]="selectedPlaceholderDocumentType" (closed)="placeholderSearchText=''"
              (click)="focusSearch('focus-placeholder-search')">
              <input type="search" id="focus-placeholder-search" class="dropdownsearchstyle"
                [(ngModel)]="placeholderSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onPlaceholderdocumentTypeSelect($event,null)">Un-select</mat-option>
              <mat-option
                *ngFor="let item of documentTypeDropdownForPlaceholder | assessmentSearch : placeholderSearchText"
                [value]="item.valueExp" (onSelectionChange)="onPlaceholderdocumentTypeSelect($event,item)">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>

            <span id="documentTypeForPlaceholder-required-msg">Please enter a document type</span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div><label for="email">Effective From Date:</label></div>
            <div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="effectiveDateConfig"
                [(ngModel)]="placeholderData.effectiveDate" (click)="onEffectiveDateClick()"
                (ngModelChange)="selectExpValueForPlaceholder($event)" [minDate]="todayDate" />
            </div>
          </div>
          <div class="col-md-6" *ngIf="isShowExpDate">
            <div><label for="email">Expiration Date:</label></div>
            <div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="placeholderData.expirationDate" [minDate]="placeholderData.effectiveDate" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div>
              <label for="email ">Placeholder Description</label>
            </div>
            <textarea id="descriptionForPlaceholder" rows="4" class="input-filed-textarea" type="text"
              [(ngModel)]="placeholderData.documentDescription"></textarea>

          </div>
        </div>
        <div class="row">
          <div class="col-md-4" *ngIf="isShowAssociatedDocumentFieldForPlaceholder">
            <div><label for="email ">Link to Parent Document</label></div>
            <div class="row row-search-container" style="margin-bottom: 1%">
              <div class="col-md-12" style="padding-left: 5px">
                <input id="userName" class="form-control" type="text" placeholder="Search"
                  [(ngModel)]="placeholderData.associatedDocumentName" (click)="searchDocumentFunction()" />
              </div>
            </div>
          </div>
          <div class="col-md-4" [hidden]="!isShowUserBelongsToFieldForPlaceholder">
            <div>
              <label for="email ">Belongs To User</label><span class="mandatory-symbol">*</span>
            </div>
            <div class="row-search-container">
              <input id="belongsToUserForPlaceholder" class="form-control" type="text" placeholder="Search"
                [(ngModel)]="placeholderData.belongsUserName" (click)="searchUserFunction('Placeholder')" />
            </div>
            <span id="belongsToUserForPlaceholder-required-msg">Please enter belongs to user</span>
          </div>
          <div class="col-md-4" [hidden]="!isShowCrFieldsForPlaceholder">
            <div>
              <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
            </div>
            <div class="row-search-container">
              <input id="crForPlaceholder" class="form-control" type="text" placeholder="Search"
                [(ngModel)]="placeholderData.crId" (click)="searchCrFunction('Placeholder')" readonly
                style="cursor:pointer;" />
            </div>

            <span id="crForPlaceholder-required-msg">Please select CR</span>
          </div>
        </div>

        <div class="row" *ngIf="isShowIsBlindedFlagForPlaceholder">
          <div class="col-md-4">
            <div><label for="email">Is Blinded</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="placeholderData.isBlinded1" [disabled]="!iSBlindTheDoc">
              <span class="active-inActive-container" *ngIf="placeholderData.isBlinded1 == true" [ngStyle]="
                  placeholderData.isBlinded1 == true
                    ? { color: 'green' }
                    : { color: '' }
                ">Blinded</span>
              <span *ngIf="placeholderData.isBlinded1 == false" [ngStyle]="
                  placeholderData.isBlinded1 == false
                    ? { color: 'red' }
                    : { color: '' }
                ">Not Blinded</span>
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditPlaceholderFunction(placeholderData)" *ngIf="visiblePlaceholderAddButton">
          <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditPlaceholderFunction(placeholderData)" *ngIf="visiblePlaceholderEditButton">
          <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
          <span class="reload_text text-white">Update</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditPlaFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #searchDocument>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchDocumentFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer">
    <app-folder-stucture [data]="'DOCUMENT'" (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addDocumentFunction()">
      <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchDocumentFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #confirmPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="email">Comments</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="comments" type="text" class="textarea-filed-continers" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="comments-required-msg">Please provide the comments</span>
        </div>
      </div>
      <br />
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="confirmOkFunc()">
        <span class="reload_text text-white">{{ buttonData.text }}</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #propertiesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelPropertiesPopupFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Properties - {{ rightClickData.folderName }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div>
    <div style="height: auto;max-height:600px !important;">
      <div class="row">
        <div class="col-md-12">
          <mat-tab-group mat-stretch-tabs class="mat-tab-container mat-elevation-z4" animationDuration="0ms"
            (selectedTabChange)="onTabChanged($event)">
            <mat-tab label="Folder Group Privilege">
              <div class="table-container">
                <div class="d-flex gap-3"></div>
                <div class="d-flex gap-3">
                  <div class="header-container">
                    <div class="">
                      <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 13px;"
                          placeholder="Search" [(ngModel)]="searchValue1">
                      </div>
                    </div>
                  </div>
                  <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReportProperties('Excel')" (keydown.enter)="openReportProperties('Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                  </div>
                </div>
                <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
                  <thead>
                    <th *ngFor="let column of columnList"
                      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{column.name}}</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                              alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngFor=" let column of columnList; let ix = index "
                        [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }"
                        class="sticky-dynamic-col1">
                        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(column.name, $event,groupAllFolderList)" /> </div>
                      </td>
                    </tr>
                    <tr *ngFor="let group of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
                      <td style="text-align: lrft;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{group.groupName}}</span></td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{group.priviledgeType}}</span></td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'"><span>{{group.assignedOn | date : uiDateTimeFormat | uppercase}}</span>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                        white-space: 'nowrap'"><span>{{group.assignedByname}}</span></td>

                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                      <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSizeForPopup | number }}
                      </div>
                      <div>
                        <ngb-pagination class="leftpadding"
                          (pageChange)="setPageForPopup(pagerForPopup.currentPage, $event,groupAllFolderList)"
                          [disabled]="false" [collectionSize]="pagerForPopup.totalItems"
                          [(page)]="pagerForPopup.currentPage" [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage"
                          [ellipses]="false" [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                      </div>
                      <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                          {{ perPage }}
                          <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                          <button ngbDropdownItem (click)="paginationCall1(10,groupAllFolderList)">10</button>
                          <button ngbDropdownItem (click)="paginationCall1(20,groupAllFolderList)">20</button>
                          <button ngbDropdownItem (click)="paginationCall1(50,groupAllFolderList)">50</button>
                        </div>
                        per page
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </mat-tab>
            <mat-tab label="Folder User Privilege">
              <div class="table-container">
                <div class="d-flex gap-3"></div>
                <div class="d-flex gap-3">
                  <div class="header-container">
                    <div class="">
                      <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 13px; width: 200px;"
                          placeholder="Search" [(ngModel)]="searchValue2">
                      </div>
                    </div>
                  </div>
                  <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReportProperties('Excel')" (keydown.enter)="openReportProperties('Excel')"
                    tabindex="0">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                  </div>
                </div>
                <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
                  <thead>
                    <th *ngFor="let column of columnList"
                      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{column.name}}</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                              alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngFor=" let column of columnList; let ix = index "
                        [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }"
                        class="sticky-dynamic-col1">
                        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(column.name, $event,groupUsersAllFolderList)" /> </div>
                      </td>
                    </tr>
                    <tr *ngFor="let user of pagedItemsForPopup | searchFilter : searchValue2; let idx = index;">
                      <td style="text-align: lrft;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{user.userOrRoleName}}</span></td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.folderAdministrator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.folderAdministrator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.author == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.author == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>

                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.reviewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.reviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.approver == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.approver == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.qa== 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img alt="" *ngIf="user.qa == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.trainingCoordinator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.trainingCoordinator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.publisher == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.publisher == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.blinded == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.blinded == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.blindbreak == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.blindbreak == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.redactor== 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.redactor == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.downloader == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.downloader == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.viewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.viewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.authorizer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.authorizer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.extensionReviewer == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.extensionReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.extensionApprover == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.extensionApprover == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.withdrawalReviewer == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.withdrawalReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.withdrawalApprover == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.withdrawalApprover == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.destructionReviewer == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.destructionReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>

                      <td style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.destructionApprover == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.destructionApprover == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                      <td style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.printer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img alt="" *ngIf="user.printer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>

                      <td style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.currentVersionViewer == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img alt="" *ngIf="user.currentVersionViewer == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                      <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSizeForPopup | number }}
                      </div>
                      <div>
                        <ngb-pagination class="leftpadding"
                          (pageChange)="setPageForPopup(pagerForPopup.currentPage, $event,groupUsersAllFolderList)"
                          [disabled]="false" [collectionSize]="pagerForPopup.totalItems"
                          [(page)]="pagerForPopup.currentPage" [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage"
                          [ellipses]="false" [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                      </div>
                      <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                          {{ perPage }}
                          <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

                          <button ngbDropdownItem (click)="paginationCall1(10,groupUsersAllFolderList)">10</button>
                          <button ngbDropdownItem (click)="paginationCall1(20,groupUsersAllFolderList)">20</button>
                          <button ngbDropdownItem (click)="paginationCall1(50,groupUsersAllFolderList)">50</button>
                        </div>
                        per page
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="d-none table-container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="search-container">
                      <span class="fa fa-search form-control-feedback"></span>
                      <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                        [(ngModel)]="searchValue2" />
                    </div>
                  </div>
                </div>
                <table class="dynamic-table-container">
                  <th style="
                      width: 200px;
                      text-align: center;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span> User or Role</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 200px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Folder Administrator</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 140px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Author</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Reviewer</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Approver</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>QA</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 120px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Training Coordinator</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Publisher</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Blinded</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Blindbreak</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Redactor</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Downloader</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Viewer</span>
                    <span class="fa-solid fa-filter"></span>
                  </th>

                  <tr *ngFor="
                      let user of groupUsersAllFolderList
                        | searchFilter : searchValue2;
                      let idx = index
                    ">
                    <td style="
                        text-align: center;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>{{ user.userOrRoleName }}</span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.folderAdministrator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="" *ngIf="user.folderAdministrator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.author == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.author == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.reviewer == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.reviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.approver == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.approver == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.qa == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.qa == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.trainingCoordinator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="" *ngIf="user.trainingCoordinator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.publisher == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.publisher == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.blinded == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.blinded == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.blindbreak == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.blindbreak == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.redactor == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.redactor == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.downloader == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.downloader == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="" *ngIf="user.viewer == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="" *ngIf="user.viewer == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      <br />
    </div>
  </div>
</ng-template>
<ng-template #extensionPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelExtensionFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 10px">
    <div>
      <div class="align-center" *ngIf="isChildExpiryLaterThanParent" style="margin-bottom: 10px;">
        <b><span style="color:red">Warning!</span>
          &nbsp;The selected 'To Be Extended Till' date is going beyond the parent document's expiry date ({{
          parentExpiryDate | date : uiDateFormat }}).</b>
      </div>
      <div class="row" *ngIf="title == 'Extend'">
        <div class="col-md-3">
          <label for="email">Expiry Date</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="extensionOrWithdrawData.currentExpiryDate" disabled />
        </div>
      </div>
      <br *ngIf="title == 'Extend'" />
      <div class="row" *ngIf="title == 'Extend'">
        <div class="col-md-3">
          <label for="email">To Be Extended Till</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="extensionOrWithdrawData.toBeExtendedTill"
            (ngModelChange)="isChildExpiryLaterThanParent" />
        </div>
      </div>
      <br *ngIf="title == 'Extend'" />
      <div class="row">
        <div class="col-md-3">
          <label for="email">Reason</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <textarea id="extedOrWithdrawReason" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="extensionOrWithdrawData.reason"></textarea>
          <span id="extedOrWithdrawReason-required-msg">Please provide the reason for {{ title }}</span>
        </div>
      </div>
      <br />
      <div class="row" *ngIf="isShowCrFields">
        <div class="col-md-3">
          <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
        </div>
        <div class="col-md-9 row-search-container">
          <input id="crForExtn" class="form-control" type="text" placeholder="Search"
            [(ngModel)]="extensionOrWithdrawData.crId" (click)="searchCrFunction('EXTNWITHDRAW')" readonly
            style="cursor:pointer;" />
          <span id="crForExtn-required-msg">Please select CR</span>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addOrUpdateExtension(extensionOrWithdrawData)">
      <span class="reload_text text-white">{{ title }}</span>
    </div>

    <button mat-stroked-button class="cancelButton" (click)="cancelExtensionFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #downloadPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDownloadFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>

  <app-document-download *ngIf="title !== 'Issuance Request'" [documentData]="documentData"
    [isPrintMode]="isPrintDownloadMode" [isOnlyPreviewMode]="isOnlyPreviewMode" (valueChange)="changeInChild($event)">
  </app-document-download>

  <app-request-issuance *ngIf="title === 'Issuance Request'" [documentData]="documentData" [isFrom]="'DOCUMENT'"
    [selectedDocList]="[documentData]" (closePopup)="cancelDownloadFunction()">
  </app-request-issuance>

</ng-template>
<ng-template #searchCr>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelCrFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Search CR</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer" style="height: 600px">
    <div class="row">
      <div class="col-md-8 group-dropdown-container">
        <label for="email">Group</label><span class="mandatory-symbol">*</span>
        <div class="col-sm-6 group-dropdown-align">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCrGroup" (closed)="crGroupsSearchText=''"
            (click)="focusSearch('focus-cr-group-search')" id="groupSearch">
            <input type="search" id="focus-cr-group-search" class="dropdownsearchstyle" [(ngModel)]="crGroupsSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onGroupValueSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : crGroupsSearchText"
              [value]="item.valueExp" (onSelectionChange)="onGroupValueSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="groupSearch-required-msg">Please choose group to select</span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="group-dropdown-align">
        <div class="search-button-continer">
          <button mat-stroked-button class="searchButton searchButton1" (click)="seachCrForDocumentsFunc()"
            [disabled]="!selectedCrGroup">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton resetButton" (click)="gridResetFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="isShowSearchedCrGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center"></th>
        <th>
          <span>Cr ID</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Description</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Initiator</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Owner</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>QA</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Business Area</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let cr of searchedCrList; let idx = index">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                  cr.searchCrChildCheckBoxs ? 'static_icon' : 'hover-menu-icons'
                ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2" [checked]="cr.searchCrChildCheckBoxs"
                  (change)="searchCrChildCheckBoxChecked($event, cr, idx)" />
              </div>
            </div>
          </td>
          <td class="row-data">{{ cr.crId }}</td>
          <td class="row-data">{{ cr.shortDescription }}</td>
          <td class="row-data">{{ cr.status }}</td>
          <td class="row-data">{{ cr.initiatedByUserName }}</td>
          <td class="row-data">{{ cr.ownerUserName }}</td>
          <td class="row-data">{{ cr.qaUserName }}</td>
          <td class="row-data">{{ cr.coreBusinessAreaName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addCrFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelCrFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mapFolderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelMapFolder()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Map Folder</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer">
    <app-distributed-folder [folderData]="folderData"></app-distributed-folder>
  </div>
</ng-template>

<ng-template #addDocumentForDocType>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAddDocForDocType()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{ buttonData.text }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer" style="height: auto !important; max-height: 570px !important">
    <div [hidden]="!isAddDocForDocType">
      <app-folder-stucture [data]="'DOCTYPEADD'"
        (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
    </div>
    <div [hidden]="!isShowAddPanel">
      <div class="row">
        <div class="col-md-12">
          <span><b>Selected Folder : </b><span>{{ selectedFolderForCreateDoc.folderName }}</span>&nbsp;&nbsp;
            <span style="cursor: pointer; text-decoration: underline; color: blue"
              (click)="selectDiffFolderFunc()">Select Different Folder</span>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-radio-group [(ngModel)]="documentAddOptionForFolder"
            (change)="chooseOptionOfAddForDocType(documentAddOptionForFolder)">
            <mat-radio-button *ngFor="let val of documentAddOptions" [value]="val">{{ val }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div>
        <div class="row" [hidden]="!isShowAddDocForDocType">
          <div class="col-md-6" style="
              height: 450px;
              border: 1px solid darkgray;
              right: 5px;
              left: 5px;
            " [hidden]="!isShowViewerForDocType">
            <div id="isNotViewableFile">
              <div class="row" *ngIf="showuploaddiv">
                <label class="control-label col-sm-4" style="margin-top: 4px" for="email"><b>Uploaded File Name : </b>
                </label>
                <div class="col-sm-4" style="margin-top: 4px; margin-left: -10%">
                  {{ previousFileName }}
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <div class="col-md-10">
                      <button *ngIf="showuploaddiv" style="margin-top: 1%" class="addButton" mat-stroked-button
                        (click)="closepdfviwer()">
                        Upload Different File
                      </button>
                    </div>
                    <div class="col-md-2" style="padding-left: 0px">
                      <a href="" *ngIf="showuploaddiv" style="margin-top: 1%"
                        (click)="downloadtemplate($event)">Download</a>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!showuploaddiv" style="margin-top: 40%; margin-left: 30%">
                <input type="file" class="file-input outPopUp" (change)="onFileSelected($event)"
                  accept={{allowedFileExtns}} #fileUpload />
              </div>
              <div id="viewerHideShow" #viewer1 style="height: 450px; margin-top: 5px"></div>
            </div>
            <div *ngIf="isViewableFile">
              <div class="row" *ngIf="isShowToUploadDiffFile">
                <label class="control-label col-sm-4" style="margin-top: 4px" for="email"><b>Uploaded File Name : </b>
                </label>
                <div class="col-sm-4" style="margin-top: 4px; margin-left: -10%">
                  {{ previousFileName }}
                </div>
                <div class="col-sm-4">
                  <button *ngIf="isShowToUploadDiffFile" style="margin-top: 1%" class="addButton" mat-stroked-button
                    (click)="closepdfviwer()">
                    Upload Different File
                  </button>
                </div>
              </div>
              <div *ngIf="!isShowToUploadDiffFile">
                <input type="file" class="file-input outPopUp" (change)="onFileSelected($event)"
                  accept={{allowedFileExtns}} #fileUpload />
              </div>
              <div class="text-center" style="color: black; text-align: center; margin-top: 25%">
                Your file is successfully uploaded. However, you will not be
                able to view the content within this platform. To do that,
                please save the document, download and view it from your local
                system.
              </div>
            </div>
          </div>
          <div [ngClass]="isShowViewerForDocType ? 'col-md-6' : 'col-md-12'" class="col-md-6" style="
              height: 450px;
              border: 1px solid darkgray;
              right: 5px;
              left: 5px;
              overflow-y: scroll;
            ">
            <div class="tab">
              <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
                animationDuration="0ms" (selectedTabChange)="onTabChanged1($event)"
                [(selectedIndex)]="selectedTabIndex">
                <mat-tab label="Document Details">
                  <ng-template mat-tab-label>
                    <span> <b>Document Details </b></span>
                  </ng-template>
                  <div class="row" style="margin-left: 0px">
                    <div class="row">
                      <div class="col-md-6">
                        <div>
                          <label for="email ">Document Name</label><span class="mandatory-symbol">*</span>
                        </div>
                        <input id="documentName" class="input-filed-continers" type="text"
                          [(ngModel)]="documentDataForDocType.documentName" />
                        <span id="documentName-required-msg">Please enter a document name</span>
                      </div>
                      <div class="col-md-2"
                        *ngIf="isVersionManuallyForDocType || documentDataForDocType.documentId != null">
                        <div><label for="email ">Version</label><span *ngIf="isVersionManuallyForDocType"
                            class="mandatory-symbol">*</span></div>
                        <input id="versionForDocType" class="input-filed-continers" type="number"
                          [(ngModel)]="documentDataForDocType.version" [disabled]="
                            documentDataForDocType.documentId != null &&
                            isVersionManuallyForDocType == false 
                          " (keypress)="validateVersion($event)" />
                        <span id="versionForDocType-required-msg">Please enter a document version</span>
                      </div>
                      <div class="col-md-4"
                        *ngIf="isDocumentNoManuallyForDocType || documentDataForDocType.documentId != null">
                        <div><label for="email ">Document No.</label><span *ngIf="isDocumentNoManuallyForDocType"
                            class="mandatory-symbol">*</span></div>
                        <input id="documentNoForDocType" class="input-filed-continers" type="text"
                          [(ngModel)]="documentDataForDocType.documentNo" [disabled]="
                            documentDataForDocType.documentId != null &&
                            isDocumentNoManuallyForDocType == false 
                          " />
                        <span id="documentNoForDocType-required-msg">Please enter a document number</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div>
                          <label for="email">Document Type</label><span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDocumentTypeForDoc"
                          (closed)="docTypeForDocSearchText=''" (click)="focusSearch('focus-doc-type-for-doc-search')"
                          id="documentType" [disabled]="isRightClickAdd" [class.disabled-cursor]="isRightClickAdd">
                          <input type="search" id="focus-doc-type-for-doc-search" class="dropdownsearchstyle"
                            [(ngModel)]="docTypeForDocSearchText" matInput placeholder="search">
                          <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="ondocumentTypeForDocSelect($event,null)">Un-select</mat-option>
                          <mat-option
                            *ngFor="let item of documentTypeDropdown | assessmentSearch : docTypeForDocSearchText"
                            [value]="item.valueExp" (onSelectionChange)="ondocumentTypeForDocSelect($event,item)">
                            {{ item.displayExp }}
                          </mat-option>
                        </mat-select>
                        <span id="documentType-required-msg">Please enter a document type</span>
                      </div>

                      <div class="col-md-6" *ngIf="
                          documentDataForDocType.templateName != null ||
                          documentDataForDocType.templateName != undefined
                        ">
                        <div><label for="email ">Template Name</label></div>
                        <input id="templateName" class="input-filed-continers" type="text"
                          [(ngModel)]="documentDataForDocType.templateName" disabled />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div>
                          <label for="email">Effective From Date:</label>
                        </div>
                        <div>
                          <input type="text" class="form-control data-picker-continer" bsDatepicker
                            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                            [(ngModel)]="documentDataForDocType.effectiveDate" (ngModelChange)="
                              selectExpValue(
                                documentDataForDocType.effectiveDate
                              )
                            " />
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="isShowExpDate">
                        <div><label for="email">Expiration Date:</label></div>
                        <div>
                          <input type="text" class="form-control data-picker-continer" bsDatepicker
                            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                            [(ngModel)]="documentDataForDocType.expirationDate" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div>
                          <label for="email ">Document Description</label><span class="mandatory-symbol">*</span>
                        </div>
                        <textarea id="descriptions" rows="4" class="input-filed-textarea" type="text" [(ngModel)]="
                            documentDataForDocType.documentDescription
                          "></textarea>
                        <span id="description-required-msg">Please enter description</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12" *ngIf="isShowAssociatedDocumentField">
                        <div>
                          <label for="email ">Link to Parent Document</label>
                        </div>
                        <div class="row row-search-container" style="margin-bottom: 1%">
                          <div class="col-md-6" style="padding-left: 5px">
                            <input id="userName1" class="form-control" type="text" placeholder="Search" [(ngModel)]="
                                documentDataForDocType.associatedDocumentName
                              " disabled />
                          </div>
                          <span class="col-md-6" *ngIf="
                              documentDataForDocType.associatedFolderPath !=
                              null
                            "><b>Path :</b>
                            {{
                            documentDataForDocType.associatedFolderPath
                            }},&nbsp; <b>Status : </b>{{ documentDataForDocType.associatedStatus }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6" *ngIf="isShowUserBelongsToField">
                        <div>
                          <label for="email ">Belongs To User</label><span class="mandatory-symbol">*</span>
                        </div>
                        <div class="row-search-container">
                          <input id="belongsToUser" class="form-control" type="text" placeholder="Search"
                            [(ngModel)]="documentDataForDocType.belongsUserName"
                            (click)="searchUserFunction('Document')" />
                        </div>
                        <span id="belongsToUser-required-msg">Please enter belongs to user</span>
                      </div>
                      <div class="col-md-6" *ngIf="isShowCrFields">
                        <div>
                          <label for="email">CR</label><span class="mandatory-symbol"
                            *ngIf="isCrFeildIsMandatory">*</span>
                        </div>
                        <div class="row-search-container">
                          <input id="cr" class="form-control" type="text" placeholder="Search"
                            [(ngModel)]="documentDataForDocType.crId" (click)="searchCrFunction('Document')" readonly
                            style="cursor:pointer;" />
                        </div>

                        <span id="cr-required-msg">Please select CR</span>
                      </div>
                    </div>
                    <div class="row" *ngIf="isShowIsBlindedFlag">
                      <div class="col-md-4">
                        <div><label for="email">Is Blinded</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="documentDataForDocType.isBlinded1"
                          [disabled]="!iSBlindTheDoc">
                          <span class="active-inActive-container" *ngIf="documentDataForDocType.isBlinded1 == true"
                            [ngStyle]="
                              documentDataForDocType.isBlinded1 == true
                                ? { color: 'green' }
                                : { color: '' }
                            ">Blinded</span>
                          <span *ngIf="documentDataForDocType.isBlinded1 == false" [ngStyle]="
                              documentDataForDocType.isBlinded1 == false
                                ? { color: 'red' }
                                : { color: '' }
                            ">Not Blinded</span>
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab *ngIf="isShowFlexifieldBlock">
                  <ng-template mat-tab-label> Additional Details </ng-template>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row" *ngFor="
                          let flexifield of flexiFieldsList;
                          let i = index
                        " style="margin-bottom: 10px">
                        <div class="col-md-3">
                          <label for="name">{{ flexifield.fieldName }}</label><span
                            *ngIf="flexifield.isMandatory == 'Y'" class="mandatory-symbol">*</span>
                        </div>
                        <div class="col-md-9" *ngIf="
                            flexifield.fieldType == 'Text Field' &&
                            flexifield.fieldDatatype != 'Date'
                          ">
                          <input attr.id="flexifield{{ i }}" class="input-filed-continers" type="text"
                            [(ngModel)]="flexifield.fieldDefaultValue" />
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>
                        <div class="col-md-9" *ngIf="
                            flexifield.fieldType == 'Text Field' &&
                            flexifield.fieldDatatype == 'Date'
                          ">
                          <input attr.id="flexifield{{ i }}" type="text" class="form-control data-picker-continer"
                            bsDatepicker [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                            [(ngModel)]="flexifield.fieldDefaultValue" />
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>
                        <div class="col-md-9" *ngIf="flexifield.fieldType == 'Large Text'">
                          <textarea attr.id="flexifield{{ i }}" type="text" class="input-filed-textarea" rows="4"
                            [(ngModel)]="flexifield.fieldDefaultValue"></textarea>
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>

                        <div class="col-md-9"
                          *ngIf="flexifield.fieldType == 'Drop Down'|| flexifield.fieldType == 'Multiselect Drop Down'">
                          <ng-multiselect-dropdown attr.id="flexifield{{ i }}" class="multiselect-container"
                            [(ngModel)]="flexifield.selectedFlexifieldValue"
                            [settings]="flexifield.fieldType === 'Multiselect Drop Down' ? multiSelectDropdownSetting : singleSelectDropdownSetting"
                            [data]="flexifield.dropdowns" (onSelect)="onFlexifieldSelect($event, flexifield)"
                            (onDeSelect)="onFlexifieldRemoved($event)">
                          </ng-multiselect-dropdown>
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>
                        <div class="col-md-9" *ngIf="
                            flexifield.fieldType == 'Vertical Radio Button' ||
                            flexifield.fieldType == 'Horizontal Radio Button'
                          ">
                          <mat-radio-group attr.id="flexifield{{ i }}" [(ngModel)]="flexifield.fieldDefaultValue"
                            [ngStyle]="
                              flexifield.fieldType == 'Vertical Radio Button'
                                ? {
                                    display: 'flex',
                                    'flex-direction': 'column'
                                  }
                                : { display: 'inline-flex' }
                            ">
                            <mat-radio-button *ngFor="let val of flexifield.dropDownValues" [value]="val">{{ val
                              }}</mat-radio-button>
                          </mat-radio-group>
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>

                        <div class="col-md-9" attr.id="flexifield{{ i }}" *ngIf="
                            flexifield.fieldType ==
                              'Vertical Checkbox Button' ||
                            flexifield.fieldType == 'Horizontal Checkbox Button'
                          ">
                          <section *ngFor="let val of flexifield.dropDownValues" [ngStyle]="
                              flexifield.fieldType == 'Vertical Checkbox Button'
                                ? {
                                    display: 'flex',
                                    'flex-direction': 'column'
                                  }
                                : { display: 'inline-flex' }
                            ">
                            <mat-checkbox (change)="
                                checkBoxChecked(flexifield, $event, val)
                              " [checked]="
                                flexifield.checkedCheckBoxValue.indexOf(val) !=
                                -1
                              ">{{ val }}</mat-checkbox>
                          </section>
                          <span>Please enter a {{ flexifield.fieldName }}</span>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addDocForDocTypeFunc()"
      *ngIf="isShowAddPanel">
      <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>

    <button mat-stroked-button class="cancelButton" (click)="cancelAddDocForDocType()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{warningMsg}}
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="okInfo()">
        <span class="reload_text text-white">OK</span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #searchUser>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName" />
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName" />
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
          [(ngModel)]="searchByLastName" />
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDesignationCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search1')">
          <input type="search" id="focus-department-search1" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDepartmentCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center">
          <div style="display: flex">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px">
              <input type="checkbox" style="zoom: 1.2" [checked]="searchUserParentCheckBox"
                (change)="searchUserDataGridParentCheckBoxChecked($event)" />
            </div>
          </div>
        </th>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>First Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Last Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Designation</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Department</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>EmailAddress</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Manager Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="
            let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData;
            let idx = index
          ">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                  listOfUsersVwDetails.searchUserChildCheckBoxs
                    ? 'static_icon'
                    : 'hover-menu-icons'
                ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedUserCheckBox1" type="checkbox" style="zoom: 1.2"
                  [checked]="listOfUsersVwDetails.searchUserChildCheckBoxs" (change)="
                    searchUserChildCheckBoxChecked(
                      $event,
                      listOfUsersVwDetails,
                      idx
                    )
                  " />
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullname }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserNameFunction()">
      <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #templatePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="canceltemplatePopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Template</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer">
      <div class="d-none table-container">
        <div class="row">
          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                [(ngModel)]="searchValue2" />
            </div>
          </div>
          <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSizeForPopup | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall2(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCall2(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container">
          <th>
            <span>Template Name.</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span>Template</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span>Template Extn</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Is Active?</span>
            <span class="fa-solid fa-filter"></span>
          </th>

          <th class="sticky-col first-col"></th>
          <tr class="data-row-container" *ngFor="
              let template of pagedItems2 | searchFilter : searchValue2;
              let idx = index
            ">
            <td class="row-data">
              <span>{{ template.templateName }}</span>
            </td>
            <td class="row-data">
              <div class="download-button-continer" mat-dialog-actions>
                <button mat-stroked-button class="downloadButton" (click)="downloadTemplates(template)">
                  <i class="fa-solid fa-download"></i> Download
                </button>
              </div>
            </td>
            <td class="row-data">{{ template.templateExtn }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="template.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="template.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table-container">
        <div class="d-flex justify-content-end gap-3 mt-1 mb-3">

          <button *ngIf="this.multiTemplateArray.length > 1" type="submit"
            style="margin-top: 1px; margin-bottom: 1px; margin-left: 40%;color:white;" class="addIconContiner"
            (click)="bulkDownloadTemplates()">
            Download
          </button>

          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable">
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex; justify-content: center; align-items: center;">
              <input id="searchTemplateParentCheckBox" type="checkbox" style="zoom: 1.2;"
                (change)="selectAllTemplate($event)" [checked]="searchTemplateParentCheckBox">
            </div>
          </th>
          <th *ngFor="let column of columnList"
            [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>{{column.name}}</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <tr>
            <td>&nbsp;</td>
            <td *ngFor=" let column of columnList; let ix = index "
              [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }" class="sticky-dynamic-col1">
              <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter3(column.name, $event,templateList)" /> </div>
            </td>
          </tr>
          <tr *ngFor="let template of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="template.searchTemplateChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="template.searchTemplateChildCheckBox"
                    (change)="onChildCheckBoxChanged($event, template, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">
              <span>{{ template.templateName }}</span>
            </td>
            <td class="row-data">
              <div class="download-button-continer" mat-dialog-actions>
                <button mat-stroked-button class="downloadButton" (click)="downloadTemplates(template)">
                  <i class="fa-solid fa-download"></i> Download
                </button>
              </div>
            </td>
            <td class="row-data">{{ template.templateExtn }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="template.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="template.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
          </tr>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSizeForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForPopup(pagerForPopup.currentPage, $event,templateList)" [disabled]="false"
                  [collectionSize]="pagerForPopup.totalItems" [(page)]="pagerForPopup.currentPage" [maxSize]="maxSize"
                  [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall1(10,templateList)">10</button>
                  <button ngbDropdownItem (click)="paginationCall1(20,templateList)">20</button>
                  <button ngbDropdownItem (click)="paginationCall1(50,templateList)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #downloadTemplatePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" (click)="cancelDownloadTemplateFunc()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title class="text-center">
      <label for="title" class="popupTitle" style="font-weight: bold !important;">Download Original Document</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span></label>
    </div>

    <div style="margin: 15px 15px">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="reason">Reason</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="deleteReason" rows="4" class="textarea-filed-continers" [(ngModel)]="reason"
            style="width:135% !important;"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="deleteReason-required-msg">Please enter reason</span>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 button-continer mt-3 pt-3" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="downloadType == 'single'" (click)="downloadTemplateForFolder()" style="cursor: pointer;">
          <span class="reload_text text-white">Download</span>
        </div>

        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="downloadType == 'bulk'" (click)="bulkDownloadTemplateForFolder()" style="cursor: pointer;">
          <span class="reload_text text-white">Download</span>
        </div>

        <button mat-stroked-button class="cancelButton" (click)="cancelDownloadTemplateFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addUserGroupPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddUserGroupPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Add UserGroup</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div style="
        height: auto;
        max-height: 570px;
        overflow-y: auto;
        padding: 10px;
        overflow-x: hidden;
      ">
      <div class="d-none table-container">
        <div class="row">
          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                [(ngModel)]="searchValue3" />
            </div>
          </div>
          <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage3 }} of {{ collectionSizeForPopup | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager3.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager3.totalItems" [(page)]="pager3.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage3" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall3(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCall3(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container" style="height: 55vh !important;">
          <thead>
            <th></th>
            <th>
              <span>Group Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Description</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span> Is Active?</span>
              <span class="fa-solid fa-filter"></span>
            </th>

            <th class="sticky-col first-col"></th>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="
                let group of pagedItems3 | searchFilter : searchValue3;
                let idx = index
              ">
              <td style="min-width: 80px; text-align: center">
                <div style="display: flex">
                  <div [ngClass]="
                      group.grouptChildCheckBoxs
                        ? 'static_icon'
                        : 'hover-menu-icons'
                    ">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px">
                    <input type="checkbox" style="zoom: 1.2" [checked]="group.grouptChildCheckBoxs" (change)="
                        dataGridGroupChildCheckBoxChecked($event, group, idx)
                      " />
                  </div>
                </div>
              </td>
              <td class="row-data">
                <span>{{ group.groupName }}</span>
              </td>
              <td class="row-data">{{ group.groupDescription }}</td>
              <td class="row-data">
                <div class="gridCheckBoxes">
                  <img alt="" *ngIf="group.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                    height="20" />
                  <img alt="" *ngIf="group.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                    height="20" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-container">
        <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
          <thead>
            <th style="min-width:60px;max-width:60px;"></th>
            <th *ngFor="let column of columnList"
              [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{column.name}}</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td *ngFor=" let column of columnList; let ix = index "
                [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }" class="sticky-dynamic-col1">
                <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                    (input)="applyFilter3(column.name, $event,dmsGroupsList)" /> </div>
              </td>
            </tr>
            <tr *ngFor="let group of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
              <td style="min-width: 80px; text-align: center">
                <div style="display: flex">
                  <div [ngClass]="
                  group.grouptChildCheckBoxs
                    ? 'static_icon'
                    : 'hover-menu-icons'
                ">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px">
                    <input type="checkbox" style="zoom: 1.2" [checked]="group.grouptChildCheckBoxs" (change)="
                    dataGridGroupChildCheckBoxChecked($event, group, idx)
                  " />
                  </div>
                </div>
              </td>
              <td class="row-data">
                <span>{{ group.groupName }}</span>
              </td>
              <td class="row-data">{{ group.groupDescription }}</td>
              <td class="row-data">
                <div class="gridCheckBoxes">
                  <img alt="" *ngIf="group.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                    height="20" />
                  <img alt="" *ngIf="group.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                    height="20" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSizeForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForPopup(pagerForPopup.currentPage, $event,dmsGroupsList)" [disabled]="false"
                  [collectionSize]="pagerForPopup.totalItems" [(page)]="pagerForPopup.currentPage" [maxSize]="maxSize"
                  [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall1(10,dmsGroupsList)">10</button>
                  <button ngbDropdownItem (click)="paginationCall1(20,dmsGroupsList)">20</button>
                  <button ngbDropdownItem (click)="paginationCall1(50,dmsGroupsList)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <div>
            <label for="email">Cascade Privilege To Child Folders</label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="cascaseToChild">
            <span class="active-inActive-container" *ngIf="cascaseToChild == true" [ngStyle]="
                cascaseToChild == true ? { color: 'green' } : { color: '' }
              ">Yes</span>
            <span *ngIf="cascaseToChild == false" [ngStyle]="
                cascaseToChild == false ? { color: 'red' } : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <br />
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserGroupFunc()">
        <img alt="" src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white"> {{ buttonData.text }}</span>
      </div>

      <button mat-stroked-button class="cancelButton" (click)="cancelAddUserGroupPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="reason"> Reason</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon1" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter reason</span>
        </div>
      </div>
      <br />
      <div class="row"
        [hidden]="buttonData.text == 'UnBlind' || buttonData.text == 'Blind' || buttonData.text =='Enable at Forms/Logs' || buttonData.text =='Disable at Forms/Logs'">
        <div>
          <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
        </div>
        <div class="row-search-container">
          <input id="cr" class="form-control" type="text" placeholder="Search" id="crForCheckout"
            [(ngModel)]="checkoutcrId" (click)="searchCrFunction('Checkout')" readonly style="cursor:pointer;" />
        </div>
        <span id="crForCheckout-required-msg">Please search and select CR</span>
      </div>
      <br
        [hidden]="buttonData.text == 'UnBlind' || buttonData.text == 'Blind' || buttonData.text =='Enable at Forms/Logs' || buttonData.text =='Disable at Forms/Logs'" />
      <div class="row"
        [hidden]="buttonData.text == 'UnBlind' || buttonData.text == 'Blind' || buttonData.text =='Enable at Forms/Logs' || buttonData.text =='Disable at Forms/Logs'"
        style="
          height: auto;
          max-height: 200px;
          overflow-y: auto;
          margin-bottom: 10px;
        ">
        <div>
          <label for="email" *ngIf="associatedDocumentListForCheckout.length != 0">Select Associated Document For
            Checkout</label>
        </div>
        <div>
          <section *ngFor="let doc of associatedDocumentListForCheckout; let i = index"
            style="display: flex; flex-direction: column; color: black">
            <mat-checkbox (change)="onChange(i, $event)" [name]="doc.documentId" [checked]="doc.checked"
              [value]="doc.documentId">
              <span>{{ doc.documentName }}({{ doc.documentNo }})</span></mat-checkbox>
          </section>
        </div>
      </div>
      <br />
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="confirmWithReasonFunc()">
        <span class="reload_text text-white"> {{ buttonData.text }}</span>
      </div>

      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #issuanceHistoryPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelIssuanceHistPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Issuance History</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer">
      <div class="d-none table-container">
        <div class="row">
          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                [(ngModel)]="searchValue" />
            </div>
          </div>
          <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSizeForPopup | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPageForIssHist(pagerForIssHist.currentPage, $event)"
              [disabled]="false" [collectionSize]="pagerForIssHist.totalItems" [(page)]="pagerForIssHist.currentPage"
              [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
              size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCallForIssHist(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCallForIssHist(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container">
          <th>
            <span> Issuance Type</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Issuance Reason</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Issued To</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span>Prints Taken</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Status</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span>Cover Page?</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Revision History?</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Amendment?</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Approval?</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Associated documents?</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Publisher Details</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Watermark</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Issued By</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Issued On</span>
            <span class="fa-solid fa-filter"></span>
          </th>

          <th class="sticky-col first-col"></th>
          <tr class="data-row-container" *ngFor="
              let issuanceHist of pagedItemsForIssHist
                | searchFilter : searchValue;
              let idx = index
            ">
            <td class="row-data">{{ issuanceHist.issuanceType }}</td>
            <td class="row-data">{{ issuanceHist.issuanceReason }}</td>
            <td class="row-data">{{ issuanceHist.issuedTo }}</td>
            <td class="row-data">{{ issuanceHist.copiedIssued }}</td>
            <td class="row-data">{{ issuanceHist.status }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.coverPage == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.coverPage == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.revisionHistory == 'Y'" src="../../assets/img/accessSymbol.svg"
                  width="20" height="20" />
                <img alt="" *ngIf="issuanceHist.revisionHistory == 'N'" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.amendment == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.amendment == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.approval == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.approval == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.associatedDocuments == 'Y'" src="../../assets/img/accessSymbol.svg"
                  width="20" height="20" />
                <img alt="" *ngIf="issuanceHist.associatedDocuments == 'N'" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" />
              </div>
            </td>
            <td class="row-data">{{ issuanceHist.publisherDetails }}</td>
            <td class="row-data">{{ issuanceHist.watermark }}</td>
            <td class="row-data">{{ issuanceHist.issuedByUser }}</td>
            <td class="row-data">
              {{ issuanceHist.issuedOn | date : uiDateTimeFormat | uppercase }}
            </td>
          </tr>
        </table>
      </div>
      <div class="table-container">
        <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable">

          <th *ngFor="let column of columnList"
            [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>{{column.name}}</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <tr class="data-row-container" *ngFor="
        let issuanceHist of pagedItemsForIssHist
          | searchFilter : searchValue1;
        let idx = index
      ">
            <td class="row-data">{{ issuanceHist.issuanceType }}</td>
            <td class="row-data">{{ issuanceHist.issuanceReason }}</td>
            <td class="row-data">{{ issuanceHist.issuedTo }}</td>
            <td class="row-data">{{ issuanceHist.copiedIssued }}</td>
            <td class="row-data">{{ issuanceHist.status }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.coverPage == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.coverPage == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.revisionHistory == 'Y'" src="../../assets/img/accessSymbol.svg"
                  width="20" height="20" />
                <img alt="" *ngIf="issuanceHist.revisionHistory == 'N'" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.amendment == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.amendment == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.approval == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="" *ngIf="issuanceHist.approval == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="" *ngIf="issuanceHist.associatedDocuments == 'Y'" src="../../assets/img/accessSymbol.svg"
                  width="20" height="20" />
                <img alt="" *ngIf="issuanceHist.associatedDocuments == 'N'" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" />
              </div>
            </td>
            <td class="row-data">{{ issuanceHist.publisherDetails }}</td>
            <td class="row-data">{{ issuanceHist.watermark }}</td>
            <td class="row-data">{{ issuanceHist.issuedByUser }}</td>
            <td class="row-data">
              {{ issuanceHist.issuedOn | date : uiDateTimeFormat | uppercase }}
            </td>
          </tr>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSizeForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForIssHist(pagerForIssHist.currentPage, $event)" [disabled]="false"
                  [collectionSize]="pagerForIssHist.totalItems" [(page)]="pagerForIssHist.currentPage"
                  [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                  size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallForIssHist(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallForIssHist(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallForIssHist(50)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #redactPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelRedactPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">{{ buttonData.text }}</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer" style="max-height: 600px;overflow-y: auto; overflow-x: hidden;">
      <div #viewer style="height: 580px; margin-top: 5px"></div>
    </div>
  </div>
</ng-template>

<ng-template #redactConfirmationPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelRedactConfirmationPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">{{ buttonData.text }}</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <app-document-download [documentData]="documentData" [isFrom]="'REDACT'" [file]="redactedDocument"
      (valueChange)="changeInChild($event)"></app-document-download>

  </div>
</ng-template>
<ng-template #documentHistoryPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelViewHistPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Document History</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer">
      <mat-tab-group selectedIndex3="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
        animationDuration="0ms" (selectedTabChange)="onTabChanged3($event)" [(selectedIndex)]="selectedTabIndex3">
        <mat-tab>
          <ng-template mat-tab-label> Revision History </ng-template>

          <div class="table-container">
            <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
              <div class="">
                <div class="search-container">
                  <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                    [(ngModel)]="searchValue1">
                </div>
              </div>
            </div>
            <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
              <thead>
                <th *ngFor="let column of columnList"
                  [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>{{column.name}}</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
              </thead>
              <tbody>
                <tr class="data-row-container" *ngFor="
                    let document of pagedItemsForViewHist
                      | searchFilter : searchValue;
                    let idx = index
                  ">
                  <td class="row-data"><a href="" (click)="downloadDoc(document,$event)">{{ document.documentNo }}</a>
                  </td>
                  <td class="row-data">{{ document.version }}</td>
                  <td class="row-data">{{ document.documentName }}</td>
                  <td class="row-data">{{ document.documentDescription }}</td>
                  <td class="row-data">{{ document.documentTypeCode }}</td>
                  <td class="row-data">{{ document.status }}</td>

                  <td class="row-data">
                    <div class="download-button-continer btn-align" mat-dialog-actions>
                      <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                        (click)="openEditor(document.revisionHistory)">
                        <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                        <span class="ms-1" style="color:azure;">View</span>
                      </button>
                    </div>
                  </td>
                  <!-- <td class="row-data">{{ document.revisionHistory }}</td> -->
                  <td class="row-data">
                    {{ document.effectiveDate | date : uiDateFormat | uppercase }}
                  </td>
                  <td class="row-data">
                    {{ document.expirationDate | date : uiDateFormat | uppercase }}
                  </td>
                  <td class="row-data">{{ document.documentExtn }}</td>
                  <td class="row-data">{{ document.documentSizeInKb }}</td>
                  <td class="row-data">{{ document.associatedDocumentNo }}</td>
                  <td class="row-data">{{ document.belongsToUser }}</td>
                  <td class="row-data">{{ document.crDetails }}</td>
                  <td class="row-data">{{ document.isDistributedFolder }}</td>
                  <td class="row-data">
                    {{ document.isAssociatedDocumentType }}
                  </td>
                  <td class="row-data">{{ document.belongsToIndividual }}</td>
                  <td class="row-data">{{ document.assignableAtTrainings }}</td>
                  <td class="row-data">{{ document.checkoutFlag }}</td>
                  <td class="row-data">{{ document.checkedinByUser }}</td>
                  <td class="row-data">
                    {{ document.checkedoutOn | date : uiDateTimeFormat | uppercase }}
                  </td>
                  <td class="row-data">{{ document.checkedoutByUser }}</td>
                  <td class="row-data">{{ document.checkinoutComments }}</td>
                  <td class="row-data">{{ document.isLatestVersion }}</td>
                  <td class="row-data">
                    {{ document.isLatestPublishedVersion }}
                  </td>
                  <td class="row-data">{{ document.isBlinded }}</td>
                  <td class="row-data">
                    {{ document.blindedOn | date : uiDateTimeFormat | uppercase }}
                  </td>
                  <td class="row-data">
                    {{ document.publishedOn | date : uiDateTimeFormat | uppercase }}
                  </td>
                  <td class="sticky-col first-col">
                    <div class="action-icons">
                      <img alt="" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20"
                        height="20" src="../../assets/img/trail-individual.svg"
                        (click)="openAuditTrail('document','individual',document)" />

                      <img alt="" *ngIf="message.isAuditTrailUser" matTooltip="Download" alt="Trail" width="20"
                        height="20" src="../../assets/img/cr_module/download.svg" (click)="docDownload(document)" />
                      <i class="fa fa-eye eye" (click)="docView($event,document)"></i>
                      <i class="fa fa-print" (click)="docPrint(document)"></i>
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSizeForRevision | number }}

              <ngb-pagination class="leftpadding"
                (pageChange)="setPageForViewHist(pagerForRevision.currentPage, $event)" [disabled]="false"
                [collectionSize]="collectionSizeForRevision" [(page)]="pagerForRevision.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>

              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                  {{ perPage }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallForViewHist(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallForViewHist(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallForViewHist(50)">50</button>
                </div>
                per page
              </div>
            </div>

          </div>
        </mat-tab>
        <mat-tab label="Move History">
          <ng-template mat-tab-label> Move History </ng-template>
          <div class="d-none table-container">
            <div class="row">
              <div class="col-md-4">
                <div class="row-search-container">
                  <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                    [(ngModel)]="searchValue" />
                </div>
              </div>
              <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSizeForRevision | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPageForViewHist($event, 0)" [disabled]="false"
                  [collectionSize]="collectionSizeForRevision" [page]="currentPageRevision" [maxSize]="maxSize"
                  [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>

                <div ngbDropdown class="d-inline-block leftpadding">
                  <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                    {{ perPage }}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="paginationCallForViewHist(10)">10</button>
                    <button ngbDropdownItem (click)="paginationCallForViewHist(20)">20</button>
                    <button ngbDropdownItem (click)="paginationCallForViewHist(50)">50</button>
                  </div>
                  per page
                </div>
              </div>
            </div>
            <table class="dynamic-table-container" style="height: 55vh !important;">
              <thead>
                <th>
                  <span> Comments</span>
                  <span class="fa-solid fa-filter"></span>
                </th>
                <th>
                  <span> From Folder Path</span>
                  <span class="fa-solid fa-filter"></span>
                </th>
                <th>
                  <span> To Folder Path</span>
                  <span class="fa-solid fa-filter"></span>
                </th>
                <th>
                  <span> Moved On</span>
                  <span class="fa-solid fa-filter"></span>
                </th>
                <th>
                  <span> Moved By</span>
                  <span class="fa-solid fa-filter"></span>
                </th>
                <th class="sticky-col first-col"></th>
              </thead>
              <tbody>
                <tr class="data-row-container" *ngFor="
                    let document of pagedItemsForMoveHist
                      | searchFilter : searchValue;
                    let idx = index
                  ">
                  <td class="row-data">{{ document.comments }}</td>
                  <td class="row-data">{{ document.fromFolderNamePath }}</td>
                  <td class="row-data">{{ document.toFolderNamePath }}</td>
                  <td class="row-data">
                    {{ document.movedOn | date : uiDateTimeFormat | uppercase }}
                  </td>
                  <td class="row-data">{{ document.movedByUser }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-container">
            <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
              <div class="">
                <div class="search-container">
                  <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                    [(ngModel)]="searchValue1">
                </div>
              </div>
            </div>
            <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
              <thead>
                <th
                  [ngStyle]="{'min-width': '150px', 'max-width': '150px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Comments</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  [ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>From Folder Path</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  [ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>To Folder Path</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  [ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Moved On</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  [ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Moved By</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div>
                        <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                </th>
              </thead>
              <tbody>
                <tr class="data-row-container" *ngFor="
                let document of pagedItemsForMoveHist
                  | searchFilter : searchValue1;
                let idx = index
                ">
                  <td class="row-data">{{ document.comments }}</td>
                  <td class="row-data">{{ document.fromFolderNamePath }}</td>
                  <td class="row-data">{{ document.toFolderNamePath }}</td>
                  <td class="row-data">
                    {{ document.movedOn | date : uiDateTimeFormat | uppercase }}
                  </td>
                  <td class="row-data">{{ document.movedByUser }}</td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center">
              <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                  <div class="pagination_text mt-3">
                    {{ showingRowsText }}
                    1-{{ perPage }} of {{ collectionSizeForMove | number }}
                  </div>
                  <div>
                    <ngb-pagination class="leftpadding"
                      (pageChange)="setPageForMoveHist(pagerForMove.currentPage, $event)" [disabled]="false"
                      [collectionSize]="pagerForMove.totalItems" [(page)]="pagerForMove.currentPage" [maxSize]="maxSize"
                      [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                    </ngb-pagination>
                  </div>
                  <div ngbDropdown class="mt-3">
                    <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                      {{ perPage }}
                      <i class="ms-1 fa-solid fa-chevron-down"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <button ngbDropdownItem (click)="paginationCallForMoveHist(10)">10</button>
                      <button ngbDropdownItem (click)="paginationCallForMoveHist(20)">20</button>
                      <button ngbDropdownItem (click)="paginationCallForMoveHist(50)">50</button>
                    </div>
                    per page
                  </div>
                </div>
              </div>
            </div>

          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</ng-template>

<ng-template #documentPropertiesPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDocPropertiesPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Properties</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <label for="email" id="versionAlert" class="me-2 flex-shrink-0" style="margin-left: 20px;">
            Document Version<span class="mandatory-symbol">*</span> :
          </label>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedVersionValue" (closed)="versionSearchText=''"
            (click)="focusSearch('focus-version-search')" class="w-100">
            <input type="search" id="focus-version-search" class="dropdownsearchstyle" [(ngModel)]="versionSearchText"
              matInput placeholder="search" maxlength="10" />
            <mat-option *ngFor="let item of versionValueDropdown | assessmentSearch : versionSearchText"
              (onSelectionChange)="onVersionSelect($event, item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="form-continer">
      <div class="tab">
        <mat-tab-group selectedIndex="0" mat-stretch-tabs class="mat-tab-container mat-elevation-z4"
          animationDuration="0ms" (selectedTabChange)="onTabChangedForProperties($event)"
          [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Document Details">
            <ng-template mat-tab-label>
              <span>Document Details</span>
            </ng-template>
            <div class="row">
              <div class="row" style="margin-bottom: 5px">
                <div class="col-md-3">
                  <div><label for="email ">Document No.</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.documentNo" disabled />
                </div>
                <div class="col-md-2">
                  <div><label for="email ">Version</label></div>
                  <input class="input-filed-continers" type="number" [(ngModel)]="documentData.version" disabled />
                </div>
                <div class="col-md-4">
                  <div><label for="email ">Document Name</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.documentName" disabled />
                </div>
                <div class="col-md-3">
                  <div><label for="email ">Document Type</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.documentTypeName"
                    disabled />
                </div>
              </div>
              <div class="row" style="margin-bottom: 5px">
                <div class="col-md-6">
                  <div><label for="email " id="description">Document Description</label></div>
                  <textarea rows="4" class="input-filed-textarea" type="text"
                    [(ngModel)]="documentData.documentDescription" disabled></textarea>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Effective From Date:</label></div>
                  <div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" disabled
                      [(ngModel)]="documentData.effectiveDate" />
                  </div>
                </div>
                <div class="col-md-3" *ngIf="documentData.expirationDate != null">
                  <div><label for="email">Expiration Date:</label></div>
                  <div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" disabled
                      [(ngModel)]="documentData.expirationDate" />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 5px">
                <div class="col-md-3" *ngIf="documentData.associatedDocumentName != null">
                  <div><label for="email ">Link to Parent Document</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.associatedDocumentName"
                    disabled />
                </div>
                <div class="col-md-3" *ngIf="documentData.belongsUserName != null">
                  <div><label for="email ">Belongs To User</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.belongsUserName"
                    disabled />
                </div>
                <div class="col-md-3" *ngIf="documentData.crDetails != null">
                  <div><label for="email ">CR</label></div>
                  <input class="input-filed-continers" type="text" [(ngModel)]="documentData.crDetails" disabled />
                </div>
                <div class="col-md-2">
                  <div><label for="email">Is Blinded</label></div>
                  <mat-slide-toggle color="primary" [(ngModel)]="documentData.isBlinded" disabled>
                    <span class="active-inActive-container" *ngIf="documentData.isBlinded == true" [ngStyle]="
                        documentData.isBlinded == true
                          ? { color: 'green' }
                          : { color: '' }
                      ">Blinded</span>
                    <span *ngIf="documentData.isBlinded == false" [ngStyle]="
                        documentData.isBlinded == false
                          ? { color: 'red' }
                          : { color: '' }
                      ">Not Blinded</span>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Revision History" *ngIf="documentData.revisionHistory != null">
            <ng-template mat-tab-label>
              <span>Revision History</span>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor(documentData.revisionHistory)">
                <i style="font-size: small;"> <i class="fa-solid fa-eye"></i></i>
              </div>
            </ng-template>
            <div style="margin-top: 1%">
              <st-editor [(ngModel)]="documentData.revisionHistory" [config]="config" disabled></st-editor>
            </div>
          </mat-tab>
          <mat-tab *ngIf="isShowFlexifieldBlock">
            <ng-template mat-tab-label> Additional Details </ng-template>
            <div class="row">
              <div class="col-md-12">
                <div class="row" *ngFor="
                    let flexifield of flexiFieldsList;
                    let i = index
                  " style="margin-bottom: 10px">
                  <div class="col-md-3">
                    <label for="name">{{ flexifield.fieldName }}</label><span *ngIf="flexifield.isMandatory == 'Y'"
                      class="mandatory-symbol">*</span>
                  </div>
                  <div class="col-md-9" *ngIf="
                      flexifield.fieldType == 'Text Field' &&
                      flexifield.fieldDatatype != 'Date'
                    ">
                    <input attr.id="flexifield{{ i }}" class="input-filed-continers" type="text"
                      [(ngModel)]="flexifield.fieldDefaultValue" disabled />
                  </div>
                  <div class="col-md-9" *ngIf="
                      flexifield.fieldType == 'Text Field' &&
                      flexifield.fieldDatatype == 'Date'
                    ">
                    <input attr.id="flexifield{{ i }}" type="text" class="form-control data-picker-continer"
                      bsDatepicker [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="flexifield.fieldDefaultValue" disabled />
                  </div>
                  <div class="col-md-9" *ngIf="flexifield.fieldType == 'Large Text'">
                    <textarea attr.id="flexifield{{ i }}" type="text" class="input-filed-textarea" rows="4"
                      [(ngModel)]="flexifield.fieldDefaultValue" disabled></textarea>
                  </div>

                  <div class="col-md-9"
                    *ngIf="flexifield.fieldType == 'Drop Down' || flexifield.fieldType == 'Multiselect Drop Down'">
                    <ng-multiselect-dropdown attr.id="flexifield{{ i }}" class="multiselect-container"
                      [(ngModel)]="flexifield.selectedFlexifieldValue"
                      [settings]="flexifield.fieldType == 'Multiselect Drop Down' ? multiSelectDropdownSetting : singleSelectDropdownSetting"
                      [data]="flexifield.dropdowns" (onSelect)="onFlexifieldSelect($event, flexifield)"
                      (onDeSelect)="onFlexifieldRemoved($event)" [disabled]="true">
                    </ng-multiselect-dropdown>

                  </div>
                  <div class="col-md-9" *ngIf="
                      flexifield.fieldType == 'Vertical Radio Button' ||
                      flexifield.fieldType == 'Horizontal Radio Button'
                    ">
                    <mat-radio-group attr.id="flexifield{{ i }}" [(ngModel)]="flexifield.fieldDefaultValue" [ngStyle]="
                        flexifield.fieldType == 'Vertical Radio Button'
                          ? {
                              display: 'flex',
                              'flex-direction': 'column'
                            }
                          : { display: 'inline-flex' }
                      ">
                      <mat-radio-button *ngFor="let val of flexifield.dropDownValues" [value]="val" disabled>{{ val
                        }}</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="col-md-9" attr.id="flexifield{{ i }}" *ngIf="
                      flexifield.fieldType ==
                        'Vertical Checkbox Button' ||
                      flexifield.fieldType == 'Horizontal Checkbox Button'
                    ">
                    <section *ngFor="let val of flexifield.dropDownValues" [ngStyle]="
                        flexifield.fieldType == 'Vertical Checkbox Button'
                          ? {
                              display: 'flex',
                              'flex-direction': 'column'
                            }
                          : { display: 'inline-flex' }
                      ">
                      <mat-checkbox (change)="
                          checkBoxChecked(flexifield, $event, val)
                        " [checked]="
                          flexifield.checkedCheckBoxValue.indexOf(val) !=
                          -1
                        " disabled>{{ val }}</mat-checkbox>
                    </section>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="taskStagesList.length > 0">
            <ng-template mat-tab-label>
              <span *ngFor="let stage of taskStagesList; let index = index">{{ stage.stageName
                }}<span *ngIf="index != taskStagesList.length - 1">/</span></span>
            </ng-template>
            <app-stage-user [data]="documentData"></app-stage-user>
          </mat-tab>
          <mat-tab *ngIf="
              documentData.documentId != undefined &&
              associatedDocumentsList.length > 0
            ">
            <ng-template mat-tab-label>
              <span>Associated Documents</span>
            </ng-template>
            <mat-tab-group selectedIndex2="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
              animationDuration="0ms" (selectedTabChange)="onTabChanged2($event)" [(selectedIndex)]="selectedTabIndex2">
              <mat-tab *ngFor="
                  let type of documentTypeListOfAssosciatedDocs;
                  let i = index
                ">
                <ng-template mat-tab-label>
                  {{ type }}
                </ng-template>
                <div class="table-container">
                  <table class="search-manager-table-container">
                    <th style="width: 140px">
                      <span>Document No</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 80px">
                      <span>Version</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 240px">
                      <span>Name</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 240px">
                      <span>Folder Path</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Effective Date</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Expiration Date</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Status</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <tr class="data-row-container" *ngFor="let doc of getDocs(type); let idx = index">
                      <td style="min-width: 140px">{{ doc.documentNo }}</td>
                      <td style="min-width: 80px">{{ doc.version }}</td>
                      <td style="min-width: 240px">{{ doc.documentName }}</td>
                      <td style="min-width: 240px">{{ doc.folderPath }}</td>
                      <td style="min-width: 120px">
                        {{ doc.effectiveDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 120px">
                        {{ doc.expirationDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 120px">{{ doc.status }}</td>
                    </tr>
                  </table>
                </div>
              </mat-tab>
            </mat-tab-group>
          </mat-tab>
          <mat-tab *ngIf="documentData.extensionCount > 0">
            <ng-template mat-tab-label> Extensions </ng-template>
            <div>
              <app-document-extension [documentData]="documentData"></app-document-extension>
            </div>
          </mat-tab>
          <mat-tab *ngIf="documentData.withdrawCount > 0">
            <ng-template mat-tab-label> Withdrawal </ng-template>
            <div>
              <app-document-withdrawal [documentData]="documentData"></app-document-withdrawal>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span>Tags</span>
            </ng-template>
            <app-document-tags [documentData]="documentData" [type]="'Tagging'"></app-document-tags>
          </mat-tab>
        </mat-tab-group>
        <br />
      </div>
    </div>
  </div>
</ng-template>
<ng-template #warningPopupTemplate>
  <div class="popup-warning">
    <button class="close close-button" (click)="okWarning()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Warning</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span></label>
    </div>
    <div style="margin: 15px 15px">
      <div class="row">
        <div class="col-md-12">
          Please upload a document before proceeding.
        </div>
      </div>
      <div class="button-continer" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="okWarning()">
          OK
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #savedReportPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSavedReportPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Redacted Documents</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer">
      <div class="d-none table-container">
        <div class="row">
          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                [(ngModel)]="searchValue" />
            </div>
          </div>
          <div class="col-md-8 pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSizeForPopup | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPageForSavedReport(pagerForPopup.currentPage, $event)"
              [disabled]="false" [collectionSize]="pagerForPopup.totalItems" [(page)]="pagerForPopup.currentPage"
              [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
              size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCallForSavedReport(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCallForSavedReport(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container">
          <th>
            <span> Status</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Type</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Document</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th>
            <span> Created On</span>
            <span class="fa-solid fa-filter"></span>
          </th>
          <th class="sticky-col first-col"></th>
          <tr class="data-row-container" *ngFor="
              let report of pagedItemForSavedReport
                | searchFilter : searchValue;
              let idx = index
            ">
            <td class="row-data">{{ report.statusWhenItsGenerated }}</td>
            <td class="row-data">{{ report.documentType }}</td>
            <td>
              <div class="download-button-continer" mat-dialog-actions style="padding: 0px">
                <button mat-stroked-button class="downloadButton" (click)="downloadRedactedFile(report)">
                  <i class="fa-solid fa-download"></i> View
                </button>
              </div>
            </td>
            <td class="row-data">
              {{ report.createdOn | date : uiDateTimeFormat | uppercase }}
            </td>
          </tr>
        </table>
      </div>
      <div class="table-container">
        <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable">
          <th
            [ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Status</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th
            [ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Type</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th
            [ngStyle]="{'min-width': '100px', 'max-width': '100px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Document</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th
            [ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Created On</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img alt="" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <tr class="data-row-container" *ngFor="
        let report of pagedItemForSavedReport
          | searchFilter : searchValue;
        let idx = index
      ">
            <td class="row-data">{{ report.statusWhenItsGenerated }}</td>
            <td class="row-data">{{ report.documentType }}</td>
            <td>
              <div class="download-button-continer" mat-dialog-actions style="padding: 0px">
                <button mat-stroked-button class="downloadButton" (click)="downloadRedactedFile(report)">
                  <i class="fa-solid fa-download"></i> View
                </button>
              </div>
            </td>
            <td class="row-data">
              {{ report.createdOn | date : uiDateTimeFormat | uppercase }}
            </td>
          </tr>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSizeForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForSavedReport(pagerForPopup.currentPage, $event)" [disabled]="false"
                  [collectionSize]="pagerForPopup.totalItems" [(page)]="pagerForPopup.currentPage" [maxSize]="maxSize"
                  [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallForSavedReport(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallForSavedReport(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallForSavedReport(50)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #moveDocumentPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelMoveDocument()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Move Document <span
        *ngIf="buttonText == 'Move Document' && this.selectedFolderToMovDocData.folderName!=null"> To
        {{this.selectedFolderToMovDocData.folderName}}</span></label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer" style="height: auto !important">
    <div class="row" style="
        height: auto;
        max-height: 350px;
        margin-bottom: 1%;
        overflow-y: auto;
      " *ngIf="!isShowMovDocCommentField">
      <app-folder-stucture [data]="'MOVEDOC'"
        (valueChange)="changeInFolderStructureChildForMove($event)"></app-folder-stucture>
    </div>
    <div class="row" [hidden]="!isShowMovDocCommentField">
      <div class="col-md-12">
        <div>
          <label for="reason"> Reason</label><span class="mandatory-symbol">*</span>
        </div>
        <textarea id="reasonForMove" rows="4" class="textarea-filed-continers" type="text"
          [(ngModel)]="reason"></textarea>
        <span id="reasonForMove-required-msg">Please enter reason</span>
      </div>
    </div>
    <br [hidden]="!isShowMovDocCommentField" />
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="moveDocFunc()">
      <span class="reload_text text-white">Move</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelMoveDocument()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #viewRelatedTrainingsPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" (click)="cancelViewRelatedTrainingsFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span></label>
    </div>

    <div class="form-continer" style="height: auto !important; padding: 15px;">
      <ng-container>
        <app-dynamic-grid *ngIf="gridConfig?.gridName" [config]="gridConfig" [clauses]="gridClause" [trail]="gridTrail"
          [report]="gridReport" [settings]="gridSettings">
        </app-dynamic-grid>
      </ng-container>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelViewRelatedTrainingsFunction()">
      <i class="fa fa-close"></i> Close
    </button>
  </div>
</ng-template>

<ng-template #bulkActionPopupTemplate>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelBulkActionPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Bulk {{ bulkActionType }}</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span></label>
  </div>

  <div style="margin: 15px 15px">
    <div class="form-continer">

      <div class="row mb-3" *ngIf="bulkActionType === 'Publish'">

        <div class="col-md-12 mb-3">
          <div><label for="bulkDocType">Document Type</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="bulkSelectedDocType"
            (closed)="bulkDocTypeSearchText=''" (click)="focusSearch('focus-bulk-doctype-search')"
            (selectionChange)="onBulkDocTypeChange($event.value)" id="bulkDocType">

            <input type="search" id="focus-bulk-doctype-search" class="dropdownsearchstyle"
              [(ngModel)]="bulkDocTypeSearchText" matInput placeholder="search">

            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>

            <mat-option *ngFor="let item of bulkDocumentTypeDropdown | assessmentSearch : bulkDocTypeSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>

          </mat-select>
        </div>

        <ng-container *ngIf="bulkSelectedDocType">
          <div class="col-md-6">
            <div><label for="bulkEffectiveDate">Effective Date</label><span class="mandatory-symbol">*</span></div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="bulkEffectiveDate" id="bulkEffectiveDate" [disabled]="!isBulkEffEditable"
              (ngModelChange)="onBulkEffectiveDateChange($event)" />
            <span id="bulkEffectiveDate-required-msg" style="display: none; color: red;">Please choose effective
              date</span>
          </div>

          <div class="col-md-6" *ngIf="isBulkExpApplicable">
            <div><label for="bulkExpirationDate">Expiration Date</label></div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="bulkExpirationDate" [minDate]="bulkEffectiveDate" id="bulkExpirationDate"
              [disabled]="!isBulkExpEditable" />
          </div>
        </ng-container>

      </div>
      <div class="row mb-3" *ngIf="bulkActionType === 'CheckIn'|| bulkActionType === 'Self Lock'">
        <div class="col-md-12">
          <label for="bulkReason">Comments</label><span class="mandatory-symbol">*</span>
          <textarea id="bulkReason" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="bulkReason"></textarea>
        </div>
      </div>
      <div class="table-container" style="max-height: 350px; overflow-y: auto;"
        *ngIf="bulkActionType === 'CheckIn' || bulkActionType === 'Self Lock' || (bulkActionType === 'Publish' && bulkSelectedDocType)">
        <table class="search-manager-table-container w-100">
          <thead>
            <tr>
              <th style="min-width: 80px; text-align: center">
                <input type="checkbox" style="zoom: 1.2" [checked]="bulkParentCheckbox"
                  (change)="toggleBulkParentCheckbox($event)" />
              </th>
              <th>Document Name</th>
              <th>Document No</th>
              <th>Version</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="let doc of bulkDocumentList; let idx = index">
              <td style="text-align: center">
                <input type="checkbox" style="zoom: 1.2" [checked]="doc.selected"
                  (change)="toggleBulkChildCheckbox($event, doc)" />
              </td>
              <td class="row-data">{{ doc.documentName }} </td>
              <td class="row-data">{{ doc.documentNo }}</td>
              <td class="row-data">{{ doc.version }}</td>
              <td class="row-data">{{ doc.status }}</td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="bulkDocumentList.length === 0" class="text-center mt-3" style="color: red;">
          No documents available for {{ bulkActionType }}.
        </div>
      </div>

    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 mt-4 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="executeBulkAction()"
        [class.disabled-cursor]="bulkDocumentList.length === 0">
        <span class="reload_text text-white">Submit</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelBulkActionPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #bulkResultPopupTemplate>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Bulk {{ bulkActionType }} Results</label>
    <label class="popupAppTitle" for="appTitle">One<span style="color: gold">QMS</span></label>
  </div>

  <div style="margin: 15px 15px">
    <div class="table-container" style="max-height: 400px; overflow-y: auto;">
      <table class="search-manager-table-container w-100">
        <thead>
          <tr>
            <th>Document No.</th>
            <th>Document Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let res of bulkActionResults">
            <td class="row-data">{{ res.documentNo }}</td>
            <td class="row-data">{{ res.documentName }}</td>
            <td class="row-data" [ngStyle]="{'color': res.isSuccess ? 'green' : 'red', 'font-weight': 'bold'}">
              <i [class]="res.isSuccess ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
              {{ res.status }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="d-flex justify-content-end gap-3 mx-3 mt-4 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeBulkResultPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<!--Excell & pdf -->
<ng-template #excelPdfPopup1>

  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #viewPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelViewPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> View </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <web-viewer [data]="viewerData"></web-viewer>
  </div>
</ng-template>

<ng-template #angularEditorTextarea>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Revision</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>